var UserAccount = {};

UserAccount.API_HOST = global_vars.api_host || "";

UserAccount.events = {

	init: function() {
		UserAccount.funcs.loadStates();

		// Events
		UserAccount.events.bindEvents();
	},

	bindEvents: function() {
		var SELF = UserAccount.events;
		var $myProfileForm = $('#myProfile');
		var $changePassword = $('#change-password');

		$myProfileForm.on('click', '#update-profile-btn', SELF.onUpdateProfile);
		$changePassword.on('click', '#change-password-submit', SELF.onChangePassword);
	},

	onChangePassword: function(event) {
		event.preventDefault;
		
		var data = UserAccount.funcs.getPasswordData();

		if(data.old_password === ""){
           UIkit.notification({message: 'Password cannot be blank', status: 'danger', pos: 'top-right'});
           return false;
        }

        if(data.new_password === ""){
           UIkit.notification({message: 'New password cannot be blank', status: 'danger', pos: 'top-right'});
           return false;
        }

        if(data.confirm_password === ""){
           UIkit.notification({message: 'Confirm password cannot be blank', status: 'danger', pos: 'top-right'});
           return false;
        }

        if(data.new_password !== data.confirm_password){
           UIkit.notification({message: 'New password do not match', status: 'danger', pos: 'top-right'});
           return false;
        }

		delete data.confirm_password;

		UserAccount.funcs.changePassword(data, function(response) {
			var message = response.message;

			if (response.success) {
            	UIkit.notification({message: message, status: 'success', pos: 'top-right'});
            	_.delay(function() {
            		window.location.href = '/logout';
            	}, 2000)
			} else {
				var message = "Wrong password";
				UIkit.notification({message: message, status: 'danger', pos: 'top-right'});
			}
		}, function(response) {
			console.log(response);

			var message = "Unable to update password.";
            UIkit.notification({message: message, status: 'danger', pos: 'top-right'});
		});		
	},

	onUpdateProfile: function(event) {
		event.preventDefault();

		var data = UserAccount.funcs.getProfileData();

		UserAccount.funcs.updateProfile(data, function(response) {
			var message = "Successfully updated the User Profile";

			if (response.success) {
            	UserAccount.funcs.updateUserSessionData(data, function(res) {
            		if (res.success) {
            			UIkit.notification({message: message, status: 'success', pos: 'top-right'});

            			_.delay(function() {
		            		location.reload();
		            	}, 1000);
            		}
            	});
			} else {
				UIkit.notification({message: message, status: 'error', pos: 'top-right'});
			}
		}, function(response) {
			console.log(response);

			var message = "Unable to update account.";
            UIkit.notification({message: message, status: 'danger', pos: 'top-right'});
		});
	},
}

UserAccount.funcs = {
	updateProfile: function(data, callback, errorCallback) {
        var data = JSON.stringify(data);

    	$.ajax({
    		data: data,
            url: UserAccount.API_HOST + "/api/user/update",
            type: "POST",
            dataType: "json",
            crossDomain: true,
            contentType: 'application/json',
            headers: {"accessToken": atob(atob(global_vars.headerValue))},
            success: callback,
            error: errorCallback
        });
    },

    changePassword: function(data, callback, errorCallback) {
    	var data = JSON.stringify(data);

    	$.ajax({
    		data: data,
            url: UserAccount.API_HOST + "/api/user/change_password",
            type: "POST",
            dataType: "json",
            crossDomain: true,
            contentType: 'application/json',
            headers: {"accessToken": atob(atob(global_vars.headerValue))},
            success: callback,
            error: errorCallback
        });
    },

    getProfileData: function() {
		var $myProfileForm = $('#myProfile');

		return {
			id: ub.user.id,
			first_name: $myProfileForm.find('input[name="first-name"]').val(),
			last_name: $myProfileForm.find('input[name="last-name"]').val(),
			state: $myProfileForm.find('select[name="state"]').val(),
			zip: $myProfileForm.find('input[name="zip"]').val(),
			default_rep_id: $myProfileForm.find('select[name="rep"] option:selected').val()
		};
	},

	getPasswordData: function() {
		var $changePassword = $('#change-password');

		return {
            user_id: ub.user.id,
			_token: $changePassword.find('input[name="_token"]').val(),
			hash: '',
			old_password: $changePassword.find('input[name="old_password"]').val(),
			new_password: $changePassword.find('input[name="password"]').val(),
			confirm_password: $changePassword.find('input[name="confirm_password"]').val()
		};
	},

	getStates: function(cb) {
		var url = location.origin + "/country-json-data/us-states.json";

		$.getJSON(url, function(states) {
			cb(states);
		});
	},

	loadStates: function() {
		UserAccount.funcs.getStates(function(response) {
			_.each(response, function(state) {
				if (ub.user.state == state.state_code) {
					$('.js-example-basic-single[name="state"]').append(new Option(state.name, state.state_code, true, true));
				} else {
					$('.js-example-basic-single[name="state"]').append(new Option(state.name, state.state_code));
				}

			});
		});

		$('.js-example-basic-single').select2();
	},

	updateUserSessionData: function(data, callback, errorCallback) {
		var data = JSON.stringify(data);

    	$.ajax({
    		data: data,
            url: location.origin + "/update-user-session-data",
            type: "POST",
            dataType: "json",
            crossDomain: true,
            contentType: 'application/json',
            headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')},
            success: callback,
            error: errorCallback
        });
	}
}

$(document).ready(UserAccount.events.init);
